module.exports = __webpack_public_path__ + "static/two_explain_en.86fe4d8d.png";